import { BackTop } from 'antd';
import { useTranslation } from 'react-i18next';
import UserService from '../../services/UserService';
import PlanTable from './Plan';
import parse from 'html-react-parser';

const UpgradePlan = () => {
    const { t } = useTranslation();
    const startDate = UserService.getStartDate();
    const endDate = UserService.getEndDate();

    return (
        <div>
            <BackTop>
                <div className="w-10 h-10 bg-purple rounded-md flex justify-center items-center shadow-md">
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
            <div className="title ">{t('common.UpgradePlan')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} /
                </span>
                <span> {t('common.UpgradePlan')} </span>
            </div>
            <div className="flex justify-center flex-col items-center my-4">
                <div className="text-[30px] font-semibold">
                    {parse(t('PricePlan.Title'))}
                </div>
                <div className="bg-[#EDEEF9] my-2 w-max px-4 py-2 rounded-lg text-base">
                    <span className="font-semibold">
                        {t('PricePlan.CurrentEffectiveDate')} :
                    </span>{' '}
                    {startDate} - {endDate}
                </div>
                <div className="flex text-xl space-x-4">
                    <div>{parse(t('PricePlan.Desc'))}</div>
                    <div className="flex items-center space-x-2">
                        <svg
                            width="35"
                            height="35"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="17.5"
                                cy="17.5"
                                r="17.5"
                                fill="#7B67FB"
                            />
                            <path
                                d="M10.4285 9.91399L11.3864 9.2646C12.2858 8.6559 13.4798 8.82587 14.1797 9.66037L15.5705 11.3239C16.176 12.0482 16.2562 13.095 15.7664 13.9118L14.4046 16.1849C14.8105 17.1696 15.4522 18.0643 16.3276 18.8695C17.1644 19.6518 18.1589 20.2559 19.2523 20.6459L21.2687 19.2419C22.0339 18.7106 23.0415 18.742 23.7687 19.3196L25.4656 20.6641C26.3123 21.3359 26.5436 22.5496 26.0063 23.5048L25.4303 24.5287C24.857 25.5475 23.8013 26.1785 22.6595 26.1832C19.9632 26.1959 17.0433 24.6697 13.8989 21.6048C10.7499 18.5352 9.11031 15.6117 8.98224 12.8379C8.92808 11.6707 9.47763 10.5581 10.4285 9.91399Z"
                                fill="white"
                            />
                        </svg>
                        <span className="text-[#65707A]">02-781-9333</span>
                    </div>
                    <div className="flex items-center space-x-2">
                        <svg
                            width="35"
                            height="35"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="17.5"
                                cy="17.5"
                                r="17.5"
                                fill="#7B67FB"
                            />
                            <path
                                d="M25.7257 11.0061C25.6462 10.998 25.5661 10.998 25.4866 11.0061H9.16035C9.05571 11.0078 8.95177 11.0234 8.85132 11.0528L17.2768 19.4433L25.7257 11.0061Z"
                                fill="white"
                            />
                            <path
                                d="M26.5886 11.8165L18.099 20.2712C17.8805 20.4884 17.5849 20.6103 17.2768 20.6103C16.9687 20.6103 16.6732 20.4884 16.4547 20.2712L8.04082 11.8807C8.01495 11.9757 8.00124 12.0737 8 12.1722V23.8338C8 24.1431 8.12286 24.4397 8.34156 24.6584C8.56026 24.8771 8.85688 25 9.16616 25H25.4924C25.8017 25 26.0983 24.8771 26.317 24.6584C26.5357 24.4397 26.6586 24.1431 26.6586 23.8338V12.1722C26.6539 12.0507 26.6303 11.9307 26.5886 11.8165ZM9.96498 23.8338H9.1545V23L13.3935 18.796L14.2156 19.6182L9.96498 23.8338ZM25.4808 23.8338H24.6645L20.4138 19.6182L21.2359 18.796L25.4749 23L25.4808 23.8338Z"
                                fill="white"
                            />
                        </svg>
                        <span className="text-[#65707A]">
                            info@whitefact.co
                        </span>
                    </div>
                    <div className="flex items-center space-x-2">
                        <svg
                            width="35"
                            height="35"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="17.5"
                                cy="17.5"
                                r="17.5"
                                fill="#7B67FB"
                            />
                            <g clipPath="url(#clip0_243_159007)">
                                <path
                                    d="M17.5 8C14.9804 8 12.5641 9.00089 10.7825 10.7825C9.00089 12.5641 8 14.9804 8 17.5C8 20.0196 9.00089 22.4359 10.7825 24.2175C12.5641 25.9991 14.9804 27 17.5 27C20.0196 27 22.4359 25.9991 24.2175 24.2175C25.9991 22.4359 27 20.0196 27 17.5C27 14.9804 25.9991 12.5641 24.2175 10.7825C22.4359 9.00089 20.0196 8 17.5 8V8ZM9.17167 18.2178H11.8211C11.8633 19.1783 11.9974 20.1326 12.2222 21.0678H9.94222C9.51705 20.1715 9.25607 19.2062 9.17167 18.2178ZM18.2178 12.5178V9.25611C19.235 9.64268 20.0709 10.3957 20.5611 11.3672C20.7775 11.7335 20.9686 12.1146 21.1311 12.5072L18.2178 12.5178ZM21.6167 13.9428C21.8616 14.8748 22.0072 15.8301 22.0494 16.7928H18.2178V13.9428H21.6167ZM16.7822 9.25611V12.5178H13.8689C14.0317 12.1248 14.2222 11.7438 14.4389 11.3778C14.9271 10.4023 15.7632 9.64525 16.7822 9.25611ZM16.7822 13.9428V16.7928H12.9611C13.0033 15.8301 13.149 14.8748 13.3939 13.9428H16.7822ZM11.8211 16.7822H9.17167C9.25607 15.7938 9.51705 14.8285 9.94222 13.9322H12.2222C11.997 14.8671 11.8626 15.8215 11.8211 16.7822ZM12.9611 18.2178H16.7822V21.0678H13.3939C13.149 20.1358 13.004 19.1804 12.9611 18.2178ZM16.7928 22.44V25.7017C15.7756 25.3151 14.9397 24.5621 14.4494 23.5906C14.2328 23.2245 14.0423 22.8435 13.8794 22.4506L16.7928 22.44ZM18.2178 25.7017V22.4928H21.1311C20.9683 22.8858 20.7778 23.2667 20.5611 23.6328C20.0709 24.6043 19.235 25.3573 18.2178 25.7439V25.7017ZM18.2178 21.015V18.165H22.0389C21.996 19.1277 21.851 20.083 21.6061 21.015H18.2178ZM23.1894 18.165H25.8389C25.7545 19.1534 25.4935 20.1187 25.0683 21.015H22.7778C22.9994 20.0967 23.1335 19.1604 23.1789 18.2178L23.1894 18.165ZM23.1894 16.74C23.1411 15.7967 23.0033 14.86 22.7778 13.9428H25.0578C25.4832 14.84 25.7439 15.8048 25.8283 16.7928L23.1894 16.74ZM24.245 12.5178H22.3556C22.0137 11.5575 21.5182 10.6592 20.8883 9.85778C22.2018 10.4474 23.3428 11.3631 24.2028 12.5178H24.245ZM14.1117 9.85778C13.4818 10.6592 12.9863 11.5575 12.6444 12.5178H10.7972C11.6572 11.3631 12.7982 10.4474 14.1117 9.85778ZM10.7867 22.5244H12.6444C12.9863 23.4847 13.4818 24.383 14.1117 25.1844C12.7945 24.586 11.6532 23.6591 10.7972 22.4928L10.7867 22.5244ZM20.8778 25.1844C21.5076 24.383 22.0031 23.4847 22.345 22.5244H24.2028C23.3375 23.6637 22.1971 24.5645 20.8883 25.1422L20.8778 25.1844Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_243_159007">
                                    <rect
                                        width="19"
                                        height="19"
                                        fill="white"
                                        transform="translate(8 8)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <span className="text-[#65707A]">Whitefact.co</span>
                    </div>
                </div>
            </div>
            <PlanTable />
            <div className="flex justify-center flex-col items-center my-4">
                <div className="flex text-xl space-x-4">
                    <div>{parse(t('PricePlan.Desc'))}</div>
                    <div className="flex items-center space-x-2">
                        <svg
                            width="35"
                            height="35"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="17.5"
                                cy="17.5"
                                r="17.5"
                                fill="#7B67FB"
                            />
                            <path
                                d="M10.4285 9.91399L11.3864 9.2646C12.2858 8.6559 13.4798 8.82587 14.1797 9.66037L15.5705 11.3239C16.176 12.0482 16.2562 13.095 15.7664 13.9118L14.4046 16.1849C14.8105 17.1696 15.4522 18.0643 16.3276 18.8695C17.1644 19.6518 18.1589 20.2559 19.2523 20.6459L21.2687 19.2419C22.0339 18.7106 23.0415 18.742 23.7687 19.3196L25.4656 20.6641C26.3123 21.3359 26.5436 22.5496 26.0063 23.5048L25.4303 24.5287C24.857 25.5475 23.8013 26.1785 22.6595 26.1832C19.9632 26.1959 17.0433 24.6697 13.8989 21.6048C10.7499 18.5352 9.11031 15.6117 8.98224 12.8379C8.92808 11.6707 9.47763 10.5581 10.4285 9.91399Z"
                                fill="white"
                            />
                        </svg>
                        <span className="text-[#65707A]">02-781-9333</span>
                    </div>
                    <div className="flex items-center space-x-2">
                        <svg
                            width="35"
                            height="35"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="17.5"
                                cy="17.5"
                                r="17.5"
                                fill="#7B67FB"
                            />
                            <path
                                d="M25.7257 11.0061C25.6462 10.998 25.5661 10.998 25.4866 11.0061H9.16035C9.05571 11.0078 8.95177 11.0234 8.85132 11.0528L17.2768 19.4433L25.7257 11.0061Z"
                                fill="white"
                            />
                            <path
                                d="M26.5886 11.8165L18.099 20.2712C17.8805 20.4884 17.5849 20.6103 17.2768 20.6103C16.9687 20.6103 16.6732 20.4884 16.4547 20.2712L8.04082 11.8807C8.01495 11.9757 8.00124 12.0737 8 12.1722V23.8338C8 24.1431 8.12286 24.4397 8.34156 24.6584C8.56026 24.8771 8.85688 25 9.16616 25H25.4924C25.8017 25 26.0983 24.8771 26.317 24.6584C26.5357 24.4397 26.6586 24.1431 26.6586 23.8338V12.1722C26.6539 12.0507 26.6303 11.9307 26.5886 11.8165ZM9.96498 23.8338H9.1545V23L13.3935 18.796L14.2156 19.6182L9.96498 23.8338ZM25.4808 23.8338H24.6645L20.4138 19.6182L21.2359 18.796L25.4749 23L25.4808 23.8338Z"
                                fill="white"
                            />
                        </svg>
                        <span className="text-[#65707A]">
                            info@whitefact.co
                        </span>
                    </div>
                    <div className="flex items-center space-x-2">
                        <svg
                            width="35"
                            height="35"
                            viewBox="0 0 35 35"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="17.5"
                                cy="17.5"
                                r="17.5"
                                fill="#7B67FB"
                            />
                            <g clipPath="url(#clip0_243_159007)">
                                <path
                                    d="M17.5 8C14.9804 8 12.5641 9.00089 10.7825 10.7825C9.00089 12.5641 8 14.9804 8 17.5C8 20.0196 9.00089 22.4359 10.7825 24.2175C12.5641 25.9991 14.9804 27 17.5 27C20.0196 27 22.4359 25.9991 24.2175 24.2175C25.9991 22.4359 27 20.0196 27 17.5C27 14.9804 25.9991 12.5641 24.2175 10.7825C22.4359 9.00089 20.0196 8 17.5 8V8ZM9.17167 18.2178H11.8211C11.8633 19.1783 11.9974 20.1326 12.2222 21.0678H9.94222C9.51705 20.1715 9.25607 19.2062 9.17167 18.2178ZM18.2178 12.5178V9.25611C19.235 9.64268 20.0709 10.3957 20.5611 11.3672C20.7775 11.7335 20.9686 12.1146 21.1311 12.5072L18.2178 12.5178ZM21.6167 13.9428C21.8616 14.8748 22.0072 15.8301 22.0494 16.7928H18.2178V13.9428H21.6167ZM16.7822 9.25611V12.5178H13.8689C14.0317 12.1248 14.2222 11.7438 14.4389 11.3778C14.9271 10.4023 15.7632 9.64525 16.7822 9.25611ZM16.7822 13.9428V16.7928H12.9611C13.0033 15.8301 13.149 14.8748 13.3939 13.9428H16.7822ZM11.8211 16.7822H9.17167C9.25607 15.7938 9.51705 14.8285 9.94222 13.9322H12.2222C11.997 14.8671 11.8626 15.8215 11.8211 16.7822ZM12.9611 18.2178H16.7822V21.0678H13.3939C13.149 20.1358 13.004 19.1804 12.9611 18.2178ZM16.7928 22.44V25.7017C15.7756 25.3151 14.9397 24.5621 14.4494 23.5906C14.2328 23.2245 14.0423 22.8435 13.8794 22.4506L16.7928 22.44ZM18.2178 25.7017V22.4928H21.1311C20.9683 22.8858 20.7778 23.2667 20.5611 23.6328C20.0709 24.6043 19.235 25.3573 18.2178 25.7439V25.7017ZM18.2178 21.015V18.165H22.0389C21.996 19.1277 21.851 20.083 21.6061 21.015H18.2178ZM23.1894 18.165H25.8389C25.7545 19.1534 25.4935 20.1187 25.0683 21.015H22.7778C22.9994 20.0967 23.1335 19.1604 23.1789 18.2178L23.1894 18.165ZM23.1894 16.74C23.1411 15.7967 23.0033 14.86 22.7778 13.9428H25.0578C25.4832 14.84 25.7439 15.8048 25.8283 16.7928L23.1894 16.74ZM24.245 12.5178H22.3556C22.0137 11.5575 21.5182 10.6592 20.8883 9.85778C22.2018 10.4474 23.3428 11.3631 24.2028 12.5178H24.245ZM14.1117 9.85778C13.4818 10.6592 12.9863 11.5575 12.6444 12.5178H10.7972C11.6572 11.3631 12.7982 10.4474 14.1117 9.85778ZM10.7867 22.5244H12.6444C12.9863 23.4847 13.4818 24.383 14.1117 25.1844C12.7945 24.586 11.6532 23.6591 10.7972 22.4928L10.7867 22.5244ZM20.8778 25.1844C21.5076 24.383 22.0031 23.4847 22.345 22.5244H24.2028C23.3375 23.6637 22.1971 24.5645 20.8883 25.1422L20.8778 25.1844Z"
                                    fill="white"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_243_159007">
                                    <rect
                                        width="19"
                                        height="19"
                                        fill="white"
                                        transform="translate(8 8)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>
                        <span className="text-[#65707A]">Whitefact.co</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpgradePlan;
